
import React from "react";
import { Chart } from "../chart";

import "./styles.scss"

const buttons = [
  { label: "5D", id: "five" },
  { label: "1M", id: "month" },
  { label: "6M", id: "month_6" },
  { label: "YTD", id: "ytd" },
  { label: "1Y", id: "year" },
  { label: "5Y", id: "year_5"},
];

class UserPerformance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: "five",
    }
  }

  onClick = id => ev => {
    if (this.state.menu === id) {
      return;
    }

    this.setState({ menu: id });
  };

  renderMenu = () => {
    const containerStyle = {
      marginTop: "1rem",
      marginBottom: "1rem",
    };
    if (!this.props.smallLayout) {
      containerStyle.float = "right";

    } else {
      containerStyle.paddingTop = "1rem";
      containerStyle.paddingBottom = "1rem";
    }

    const spanStyle = {
      borderStyle: "solid",
      borderWidth: "thin",
      padding: "0.5rem",
      cursor: "pointer",
    };
    const spanSelected = {
      ...spanStyle,
      color: "#FFF",
      backgroundColor: "#000",
    };

    return (
      <div style={containerStyle}>
        { buttons.map(({label, id}, index) => {
          const style = this.state.menu === id ? spanSelected : spanStyle;
          return (
            <span style={style} onClick={this.onClick(id)} key={index}>
              { label }
            </span>
          )
        })}
      </div>
    );
  };

  getData = () => {
    let data = null;
    switch(this.state.menu) {
      case 'five':
        data = this.props.data.days_5;
        break;
      case 'month':
        data = this.props.data.month;
        break;
      case 'month_6':
        data = this.props.data.month_6;
        break;
      case 'year':
        data = this.props.data.year_1;
        break;
      case 'year_5':
        data = this.props.data.year_5;
        break;
      case 'ytd':
        data = this.props.data.ytd_weekly
          || this.props.data.ytd_daily;
        break;
      default:
        data = this.props.data.days_5;
        break;
    }
    return data;
  };

  getTimeline = () => {
    const data = this.getData();
    return data.map(item => {
      return {
        label: item.date,
        t: item.t_full,
      }
    });
  };

  getTickData = () => {
    const data = this.getData();
    const line = {
      color: {r: 0, g: 0, b: 0},
      data: data.map(item => item.price),
    };
    return [ line ];
  };

  render = () => {

    const containerStyle = {
      width: "100%",
    };

    return (
      <div className="user-performance-responsive">
        <div style={containerStyle}>
          { this.renderMenu() }
          <Chart
            timeline={this.getTimeline()}
            tickData={this.getTickData()}
            xAxisHeightRem={"2rem"}
            yAxisWidthRem={"3.5rem"}
            widthRem={this.props.widthRem}
            heightRem={this.props.heightRem}/>
        </div>
      </div>
    );
  }
}

export { UserPerformance };
